import { Box, Header, Text } from '@fhs-legacy/universal-components';
import { theme } from 'styles/configure-theme';

export const Wrapper = Box.withConfig({
  flexDirection: 'column',
  justifyContent: 'center',
});

export const HeaderText = Header.withConfig({
  variant: 'headerTwo',
  textAlign: 'center',
});

export const CustomText = Text.withConfig({
  color: theme.token('text-active'),
});

export const BodyText = Text.withConfig({
  _web: {
    textAlign: 'center',
    marginY: '$4',
  },
});
